import { OrbitControls, Stats } from "@react-three/drei";

export function Camera({orbitRef}){
  return(
    <>
    <OrbitControls enableRotate={false} enableZoom={false} enablePan={false} ref={orbitRef} target={[0,1.8,-1]} minDistance={1} maxDistance={10}/>
    </>
  )
}